import { Link } from 'react-router-dom';

export default function OBHero() {
  return (
    <section className="relative w-full overflow-hidden bg-[#0f1117] pt-20 pb-16">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/95" />
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
          Özel Bulut İşletim Sistemi
        </div>
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-5 leading-tight">
          Sanallaştırma Alternatifi mi yoksa<br />
          <span className="text-[#e8600a]">Özel Bulut İşletim Sistemi mi?</span>
        </h1>
        <p className="text-lg text-gray-300 mb-3">
          Önümüzdeki On Yıl İçin Altyapınızı Belirleyecek Karar
        </p>
        <p className="text-gray-400 mb-10 max-w-2xl mx-auto leading-relaxed">
          Hiper yönetici değişimleri lisans maliyetlerini çözer. Altyapı konsolidasyonu, beş kat daha fazla operasyonel yükü çözer.
          <strong className="text-gray-200"> Hangisi organizasyonunuza daha pahalıya mal oluyor?</strong>
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="https://www.verge.io/infrastructure-decision-framework/"
            target="_blank"
            rel="nofollow noreferrer"
            className="bg-[#e8600a] hover:bg-[#cc5208] text-white font-semibold px-7 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Çerçeveye Erişin
          </a>
          <a
            href="https://www.verge.io/white-paper-evaluating-dell-private-cloud-vs-vergeos/"
            target="_blank"
            rel="nofollow noreferrer"
            className="border border-white/30 text-white hover:bg-white/10 font-semibold px-7 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Teknik Raporu İndirin
          </a>
          <Link
            to="/iletisim"
            className="border border-[#e8600a]/60 text-[#e8600a] hover:bg-[#e8600a]/10 font-semibold px-7 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Demo Planlayın
          </Link>
        </div>
      </div>
    </section>
  );
}
